// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { LiftType } from "../archive/lift-type";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * GET /keys/light — minimal key info.
 */
export class KeyLight implements flatbuffers.IUnpackableObject<KeyLightT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): KeyLight {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsKeyLight(bb: flatbuffers.ByteBuffer, obj?: KeyLight): KeyLight {
    return (obj || new KeyLight()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsKeyLight(bb: flatbuffers.ByteBuffer, obj?: KeyLight): KeyLight {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new KeyLight()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  adapterId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  fbsDeviceType(): LiftType {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : LiftType.ELEVATOR;
  }

  encodedType(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  messageContent(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  messageValue(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  position(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  floorsBased(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  unitsBased(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  debounceTime(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  static startKeyLight(builder: flatbuffers.Builder) {
    builder.startObject(10);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addAdapterId(builder: flatbuffers.Builder, adapterIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, adapterIdOffset, 0);
  }

  static addFbsDeviceType(builder: flatbuffers.Builder, fbsDeviceType: LiftType) {
    builder.addFieldInt8(2, fbsDeviceType, LiftType.ELEVATOR);
  }

  static addEncodedType(builder: flatbuffers.Builder, encodedType: number) {
    builder.addFieldInt16(3, encodedType, 0);
  }

  static addMessageContent(builder: flatbuffers.Builder, messageContent: number) {
    builder.addFieldInt16(4, messageContent, 0);
  }

  static addMessageValue(builder: flatbuffers.Builder, messageValue: number) {
    builder.addFieldInt32(5, messageValue, 0);
  }

  static addPosition(builder: flatbuffers.Builder, position: number) {
    builder.addFieldInt16(6, position, 0);
  }

  static addFloorsBased(builder: flatbuffers.Builder, floorsBased: boolean) {
    builder.addFieldInt8(7, +floorsBased, +false);
  }

  static addUnitsBased(builder: flatbuffers.Builder, unitsBased: boolean) {
    builder.addFieldInt8(8, +unitsBased, +false);
  }

  static addDebounceTime(builder: flatbuffers.Builder, debounceTime: number) {
    builder.addFieldInt32(9, debounceTime, 0);
  }

  static endKeyLight(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    return offset;
  }

  unpack(): KeyLightT {
    return new KeyLightT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.adapterId() !== null ? this.adapterId()!.unpack() : null,
      this.fbsDeviceType(),
      this.encodedType(),
      this.messageContent(),
      this.messageValue(),
      this.position(),
      this.floorsBased(),
      this.unitsBased(),
      this.debounceTime(),
    );
  }

  unpackTo(_o: KeyLightT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.adapterId = this.adapterId() !== null ? this.adapterId()!.unpack() : null;
    _o.fbsDeviceType = this.fbsDeviceType();
    _o.encodedType = this.encodedType();
    _o.messageContent = this.messageContent();
    _o.messageValue = this.messageValue();
    _o.position = this.position();
    _o.floorsBased = this.floorsBased();
    _o.unitsBased = this.unitsBased();
    _o.debounceTime = this.debounceTime();
  }

  unpackFields(...fields: string[]): KeyLightT {
    const t = new KeyLightT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("adapter_id")) {
      t.adapterId = this.adapterId() !== null ? this.adapterId()!.unpack() : null;
    }
    if (fieldSet.has("fbs_device_type")) {
      t.fbsDeviceType = this.fbsDeviceType();
    }
    if (fieldSet.has("encoded_type")) {
      t.encodedType = this.encodedType();
    }
    if (fieldSet.has("message_content")) {
      t.messageContent = this.messageContent();
    }
    if (fieldSet.has("message_value")) {
      t.messageValue = this.messageValue();
    }
    if (fieldSet.has("position")) {
      t.position = this.position();
    }
    if (fieldSet.has("floors_based")) {
      t.floorsBased = this.floorsBased();
    }
    if (fieldSet.has("units_based")) {
      t.unitsBased = this.unitsBased();
    }
    if (fieldSet.has("debounce_time")) {
      t.debounceTime = this.debounceTime();
    }
    return t;
  }
}

export class KeyLightT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public adapterId: UuidT | null = null,
    public fbsDeviceType: LiftType = LiftType.ELEVATOR,
    public encodedType: number = 0,
    public messageContent: number = 0,
    public messageValue: number = 0,
    public position: number = 0,
    public floorsBased: boolean = false,
    public unitsBased: boolean = false,
    public debounceTime: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const adapterId = this.adapterId !== null ? this.adapterId!.pack(builder) : 0;

    KeyLight.startKeyLight(builder);
    KeyLight.addId(builder, id);
    KeyLight.addAdapterId(builder, adapterId);
    KeyLight.addFbsDeviceType(builder, this.fbsDeviceType);
    KeyLight.addEncodedType(builder, this.encodedType);
    KeyLight.addMessageContent(builder, this.messageContent);
    KeyLight.addMessageValue(builder, this.messageValue);
    KeyLight.addPosition(builder, this.position);
    KeyLight.addFloorsBased(builder, this.floorsBased);
    KeyLight.addUnitsBased(builder, this.unitsBased);
    KeyLight.addDebounceTime(builder, this.debounceTime);

    return KeyLight.endKeyLight(builder);
  }

  clone(): KeyLightT {
    const obj = new KeyLightT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.adapterId = this.adapterId !== null ? this.adapterId!.clone() : null;
    obj.fbsDeviceType = this.fbsDeviceType;
    obj.encodedType = this.encodedType;
    obj.messageContent = this.messageContent;
    obj.messageValue = this.messageValue;
    obj.position = this.position;
    obj.floorsBased = this.floorsBased;
    obj.unitsBased = this.unitsBased;
    obj.debounceTime = this.debounceTime;
    return obj;
  }

  equals(other: KeyLightT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.adapterId !== null && other.adapterId !== null) {
      if (!this.adapterId!.equals(other.adapterId!)) return false;
    } else if (this.adapterId !== other.adapterId) return false;
    if (this.fbsDeviceType !== other.fbsDeviceType) return false;
    if (this.encodedType !== other.encodedType) return false;
    if (this.messageContent !== other.messageContent) return false;
    if (this.messageValue !== other.messageValue) return false;
    if (this.position !== other.position) return false;
    if (this.floorsBased !== other.floorsBased) return false;
    if (this.unitsBased !== other.unitsBased) return false;
    if (this.debounceTime !== other.debounceTime) return false;
    return true;
  }
}

export function verifyKeyLight(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkScalarField(tablePos, 8, 1);
    verifier.checkScalarField(tablePos, 10, 2);
    verifier.checkScalarField(tablePos, 12, 2);
    verifier.checkScalarField(tablePos, 14, 4);
    verifier.checkScalarField(tablePos, 16, 2);
    verifier.checkScalarField(tablePos, 18, 1);
    verifier.checkScalarField(tablePos, 20, 1);
    verifier.checkScalarField(tablePos, 22, 4);
  } finally {
    verifier.popDepth();
  }
}
